// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead___FAgb","bigColWidth":"Table_bigColWidth__338i5","biggerColWidth":"Table_biggerColWidth__1TcdC","row":"Table_row__Jj44J","col":"Table_col__o_76U"};